
import { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'

import Link from '@/components/Link'
import Button from "@/components/Button";
import SocialRegister from "@/components/SocialRegister";
import { ChipIcon } from "@heroicons/react/solid";
import RequestAccountCta from "@/components/RequestAccountCta";
import Tabs from '@/components/Tabs';
import modalRoutes from '@/modalRoutes';
import StakeTable from '@/components/StakeTable';
import { AuthContext } from '@/contexts/AuthContext';
import { StakeContext } from '@/contexts/StakeContext';
import RaceTable from '../../components/RaceTable';
import { useFirestore } from 'react-redux-firebase';
import { format } from 'date-fns'
import { convertAmount } from '../../utils/currencyResolver';

import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/solid'

export default function Home() {
  const { auth } = useContext(AuthContext)
  return (
    <>
      <Helmet>
        <title>Runescape Staking No Limits</title>
      </Helmet>
      <div>
        <div className="bg-gray-800 pt-4 md:pt-8">
          <div className="container">
            <div className="relative bg-gray-900 overflow-hidden rounded-lg shadow-lg">
              <img src="/Space_Header_Full.png" alt="" className="opacity-20 md:opacity-100 object-cover min-h-[225px] max-h-[360px] w-full" />
              <div className="absolute container inset-0 flex items-center">
                {auth?.uid ? <AuthenticatedView /> : <UnauthenticatedView />}
              </div>
            </div>
          </div>
        </div>
        <div className="container py-12">
          <div className="grid gap-4 md:grid-cols-2 md:dark:grid-cols-1">
            <Link className="block group" to="/arena">
            <div className="transform overflow-hidden rounded-md shadow-lg transition-all duration-300 group-hover:-translate-y-1">
                <img src="/duelarena-enter.png" alt="" className="object-cover overflow-hidden h-64 w-full block" />
                <p className="bg-gray-900 py-3.5 px-4 text-center -mt-1 w-full">Enter the Arena</p>
              </div>
            </Link>
            <Link className="block group" to="/leaderboard">
              <div className="transform overflow-hidden rounded-md shadow-lg transition-all duration-300 group-hover:-translate-y-1">
                <img src="/leaderboard-enter.png" alt="" className="object-cover overflow-hidden h-64 w-full block" />
                <p className="bg-gray-900 py-3.5 px-4 text-center -mt-1 w-full">Go to Leaderboards</p>
              </div>
            </Link>
          </div>
        </div>
        <RequestAccountCta />
        <div className="container py-8">
          <RecentBetsTable />
        </div>
      </div>
    </>
  )
}

const AuthenticatedView = () => {
  const { user } = useContext(AuthContext)
  return (
    <div className="flex items-center justify-center lg:justify-start">
      <div className="grid gap-3 flex-1">
        <p className="text-xl">Welcome back, <span className="tracking-tightest font-bold">{user?.username}</span></p>
        <p className="text-sm">Simple Signup, Instant Withdrawals and Exclusive VIP Benefits!</p>
        <div className="flex">
          <Button rounded="rounded-full" link to="/arena" className="py-2.5 px-6">Enter the arena</Button>
        </div>
      </div>
    </div>
  )
}

const UnauthenticatedView = () => {
  return (
    <div className="flex items-center justify-center lg:justify-start">
      <div className="text-center grid gap-3">
        <p className="text-xl">Play <span className="tracking-tightest font-bold">Smarter</span></p>
        <p className="text-sm">Simple Signup, Instant Withdrawals and Exclusive VIP Benefits!</p>
        <div className="w-72 mx-auto grid gap-3">
          <Button link to={modalRoutes.REGISTER} rounded="rounded-full" className="py-3.5">Register Instantly</Button>
          {/* <p className="text-sm">Or join now with</p> */}
          {/* <SocialRegister google /> */}
        </div>
      </div>
    </div>
  )
}

const RecentBetsTable = () => {
  const firestore = useFirestore()
  const { racesData } = useContext(AuthContext)
  const [duelsData, setDuelsData] = useState([])
  useEffect(() => {
    firestore.collection("duels").where("fightEnd", "!=", null).orderBy("fightEnd", "desc").onSnapshot((snapshot) => {
      let duelsArr = []
      snapshot.docs.forEach(doc => {
        duelsArr.push({ id: doc.id, ...doc.data() })
      })
      setDuelsData(duelsArr)
    })
  }, [])

  return (
    <Tabs
      items={[
        {
          title: 'All Duels',
          panel: <div className="overflow-x-auto">
            <table className="w-full text-gray-300">
              <thead className="mb-4">
                <tr>
                  <th className="w-24 p-4 text-sm font-medium text-left whitespace-nowrap">Time</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 1</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 2</th>
                  <th className="w-24 p-4 text-sm font-medium text-center whitespace-nowrap">Wager</th>
                  <th className="w-24 p-4 text-sm font-medium text-right whitespace-nowrap">Payout</th>
                </tr>
              </thead>
              <tbody>
                {duelsData?.slice(0, 8)?.map(item => <TableRow item={item} key={item.id} />)}
              </tbody>
            </table>
          </div>
        },
        {
          title: 'Highrollers',
          panel: <div className="overflow-x-auto">
            <table className="w-full text-gray-300">
              <thead className="mb-4">
                <tr>
                  <th className="w-24 p-4 text-sm font-medium text-left whitespace-nowrap">Time</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 1</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 2</th>
                  <th className="w-24 p-4 text-sm font-medium text-center whitespace-nowrap">Wager</th>
                  <th className="w-24 p-4 text-sm font-medium text-right whitespace-nowrap">Payout</th>
                </tr>
              </thead>
              <tbody>
                {duelsData?.filter(duel => duel.wager >= 500000000)?.slice(0, 8)?.map(item => <TableRow item={item} key={item.id} />)}
              </tbody>
            </table>
          </div>
        },
        {
          key: 'Races',
          title: racesData?.length > 0 ? <div className="flex items-center">Races <span className="ml-1 h-2 w-2 block rounded-full bg-[#00fe00]"></span></div> : 'Races',
          panel: <RaceTable data={racesData[0]} />
        },
      ]}
      routing={false}
      navWrapperClass="flex justify-start mb-4"

    />
  )
}

const TableRow = ({ item }) => {
  const getFormatted = date => {
    const data = format(new Date(item?.fightEnd?.seconds * 1000), 'K:mm aa')
    const isMidnight = "0:" == data.substring(0,2)
    if (isMidnight) {
      return "12:" + data.slice(2)
    } else {
      return data
    }
  }
  return (
    <tr className="p-4 rounded odd:bg-gray-900 rounded">
      <td className="p-4 text-sm text-gray-200 rounded-l">{getFormatted()}</td>
      <td className="p-4 text-sm text-gray-200 truncate">{translateUser(item, "created")}</td>
      <td className="p-4 text-sm text-gray-200 truncate">{translateUser(item, "joined")}</td>
      <td className="p-4 text-sm text-gray-200">
        <div className="flex items-center justify-center">
          <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" /> {convertAmount(item.wager)}
        </div>
      </td>
      <td className="p-4 text-sm rounded-r">
        <div className="flex items-center justify-end">
          <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" /> {convertAmount(item.payout)}
        </div>
      </td>
    </tr>
  )
}

const translateUser = (item, slot) => {
  const property = slot == "created" ? item.createdUsername : item.joinedUsername
  let winner

  if (item.winner.id == item.created.id) {
    winner = "created"
  } else {
    winner = "joined"
  }

  if (!property) return (
    <p className="flex items-center justify-center space-x-1">
      {winner === slot ? <CheckCircleIcon className="h-4 w-4 text-green-500 flex-shrink-0" /> : <XCircleIcon className="h-4 w-4 text-red-500 flex-shrink-0" />}
      <span className="font-medium">Hidden</span>
    </p>
  )
  return (
    <Link className="flex items-center justify-center space-x-1 text-gray-200" to={{ search: '&modal=user&name=' + property }}>
      {winner === slot ? <CheckCircleIcon className="h-4 w-4 text-green-500 flex-shrink-0" /> : <XCircleIcon className="h-4 w-4 text-red-500 flex-shrink-0" />}
      <span className="text-gray-200 hover:text-gray-200 transition duration-200 font-medium">{property}</span>
    </Link>
  )
}